import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare Distribution has no pane of its own — land on the first sub-tab.
export const Route = createFileRoute('/_app/admin/transitions/jobs/$jobId/distribution/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/admin/transitions/jobs/$jobId/distribution/x', params })
  },
})
